// Carrusel de reseñas — sin librerías.
// Dos variantes, detectadas por estructura:
// 1) Home (sin [data-tz-resenas-pista]): scroll nativo + scroll-snap,
//    como siempre (varias tarjetas visibles, swipe táctil).
// 2) Página de producto (.tz-resenas--producto, con
//    [data-tz-resenas-pista]): una tarjeta completa a la vez, navegada
//    por índice con transform: translateX — sin autoplay, el comprador
//    controla el ritmo.
(function () {
  function iniciarScrollNativo(seccion, carrusel, btnPrev, btnNext) {
    function anchoPaso() {
      var card = carrusel.querySelector('.tz-resenas__card');
      if (!card) return carrusel.clientWidth;
      var estilo = window.getComputedStyle(carrusel);
      var gap = parseFloat(estilo.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function actualizarFlechas() {
      if (!btnPrev || !btnNext) return;
      var maxScroll = carrusel.scrollWidth - carrusel.clientWidth - 2;
      btnPrev.disabled = carrusel.scrollLeft <= 2;
      btnNext.disabled = carrusel.scrollLeft >= maxScroll;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        carrusel.scrollBy({ left: -anchoPaso(), behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        carrusel.scrollBy({ left: anchoPaso(), behavior: 'smooth' });
      });
    }

    carrusel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        carrusel.scrollBy({ left: anchoPaso(), behavior: 'smooth' });
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        carrusel.scrollBy({ left: -anchoPaso(), behavior: 'smooth' });
      }
    });

    carrusel.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  function iniciarUnaPorVez(pista, btnPrev, btnNext, carrusel) {
    var tarjetas = Array.prototype.slice.call(pista.children);
    var total = tarjetas.length;
    if (total === 0) return;

    var indice = 0;

    function actualizarFlechas() {
      if (!btnPrev || !btnNext) return;
      btnPrev.disabled = indice <= 0;
      btnNext.disabled = indice >= total - 1;
    }

    function irA(nuevoIndice) {
      indice = Math.max(0, Math.min(nuevoIndice, total - 1));
      pista.style.transform = 'translateX(-' + (indice * 100) + '%)';
      actualizarFlechas();
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { irA(indice - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { irA(indice + 1); });

    carrusel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        irA(indice + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        irA(indice - 1);
      }
    });

    window.addEventListener('resize', function () { irA(indice); });

    irA(0);
  }

  function iniciar(seccion) {
    var carrusel = seccion.querySelector('[data-tz-resenas-carrusel]');
    var btnPrev = seccion.querySelector('[data-tz-resenas-prev]');
    var btnNext = seccion.querySelector('[data-tz-resenas-next]');
    if (!carrusel) return;

    var pista = seccion.querySelector('[data-tz-resenas-pista]');
    if (pista) {
      iniciarUnaPorVez(pista, btnPrev, btnNext, carrusel);
    } else {
      iniciarScrollNativo(seccion, carrusel, btnPrev, btnNext);
    }
  }

  document.querySelectorAll('.tz-resenas').forEach(iniciar);
})();
